import { render, staticRenderFns } from "./placement-period.vue?vue&type=template&id=13ae87cd"
import script from "./placement-period.vue?vue&type=script&lang=js"
export * from "./placement-period.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports